 import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { LatestBlogCard, Title } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { blog_helper } from "@/helpers/blog_helper";
import { trimText } from "@/functions/trimText";
import LatestNews from "../LatestNews";

export default function LatestBlogs({ className, title, newsTitle, backgroundColor, variant, author = null }) {

  let items = blog_helper.fetch({ limit: 3, author: author?.name });

  if (!items.length && items.length < 1) {
    items = blog_helper.fetch();

    items = items.filter((item) => item.tags ? item.tags.map(
      (tag) => author.specialisms 
      ? author.specialisms.map((specialism) => specialism.toLowerCase() === tag.toLowerCase()) 
      : true) : true
    );

    items = items.slice(0, 3);
  }

  return (
    <div style={{backgroundColor: backgroundColor}} className={clsx(className, classes.LatestBlogs)}>
      <Container className={`text-center ${classes.blogs}`}>
        <Title tag="div" title={title} className={`h2 ${variant ?? "primary"} ${classes.header}`} highlight={false} variant={variant ?? "primary"} />
        <Row className="mb-md-4">
          {items.map(({ title, body, image, publish_date, category, url_slug, minutes }, k) => (
            <Col key={k} xs={12} md={4} className={clsx(classes.card_height)}>
              <LatestBlogCard
                className="h-100"
                title={title}
                description={trimText(body)}
                img={image || ""}
                category={category}
                publish_date={publish_date}
                minutes={minutes}
                href={getRoute("blogPost", { url_slug })}
              />
            </Col>
          ))}
        </Row>
      </Container>
      { newsTitle &&
        <div>
          <hr className={classes.breakline} />
          <LatestNews newsTitle={newsTitle} />
        </div>
      } 
    </div>
  );
}

LatestBlogs.defaultProps = {
  className: "py-4 py-md-5",
  title: null,
  button: {
    label: "View more blogs",
    href: getRoute("blog"),
  },
};

LatestBlogs.propTypes = {
  className: PropTypes.string,
  title: PropTypes.any,
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
};
